var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 62.5 62.5",
    style: {
      enableBackground: "new 0 0 62.5 62.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.9,46.1l-7.8-7.8c-2.1-2.1-5.6-2.1-7.8,0l-3.5,3.5c-1.6,1.6-4.3,1.6-5.9,0L20.6,26.5c-1.6-1.6-1.6-4.3,0-5.9 c0.6-0.6,2.2-2.2,3.5-3.5c2.1-2.1,2.2-5.6,0-7.8l-7.8-7.7c-2.1-2.1-5.6-2.1-7.8,0C7,3.2,6.5,3.7,5.8,4.4c-7.7,7.7-7.7,20.3,0,28 L30,56.7c7.7,7.7,20.3,7.7,28,0l2.8-2.8C63,51.7,63,48.2,60.9,46.1z M50.5,40.9l7.8,7.8c0.7,0.7,0.7,1.9,0,2.6L57,52.5L46.6,42.2 l1.3-1.3C48.6,40.2,49.8,40.2,50.5,40.9z M13.8,4.2l7.8,7.7c0.7,0.7,0.7,1.9,0,2.6l-1.3,1.3L9.9,5.5l1.3-1.3 C11.9,3.5,13.1,3.5,13.8,4.2z M32.6,54.1L8.4,29.8c-6-6-6.3-15.4-1-21.7l10.3,10.3c-2.7,3.1-2.6,7.8,0.3,10.7l15.3,15.3c0,0,0,0,0,0 c2.9,2.9,7.6,3.1,10.7,0.3l10.3,10.3C48,60.4,38.6,60.1,32.6,54.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.0322b6392358861a3363738217ee2c64.svg";
export { ForwardRef as ReactComponent };